<template>
  <div>
    <nav-bar placeholder title="我的驾驶舱" />
    <div style="padding: 20px 0">
      <div v-for="item in list" :key="item.TenantCode">
        <h2
          style="
            padding: 0;
            margin: 0 0 4px 20px;
            font-size: 16px;
            font-weight: normal;
          "
        >
          {{ item.TenantName }}
        </h2>
        <van-cell-group style="margin-bottom: 20px">
          <van-cell
            center
            is-link
            title="CEO驾驶舱"
            value=""
            @click="open(`https://${item.TenantCode}.tengyucloud.com/`)"
          >
            <template #label>
              <a
                href="javascript:;"
                @click.stop="
                  copy(`https://${item.TenantCode}.tengyucloud.com/`)
                "
              >
                https://{{ item.TenantCode }}.tengyucloud.com/
              </a>
            </template>
          </van-cell>
          <van-cell
            center
            is-link
            label="案例云"
            title="案例云"
            value=""
            @click="open(`https://wx.tengyuone.com/${item.TenantCode}/case/`)"
          >
            <template #label>
              <a
                href="javascript:;"
                @click.stop="
                  copy(`https://wx.tengyuone.com/${item.TenantCode}/case/`)
                "
              >
                https://wx.tengyuone.com/{{ item.TenantCode }}/case/
              </a>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>
<script>
  import NavBar from '@/components/NavBar'
  import store from '@/store'
  import { Toast, Dialog } from 'vant'
  export default {
    components: {
      NavBar,
    },
    data() {
      return {
        list: [],
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.getList()
      },
      getList() {
        const userInfo = store.getters['user/getUserInfo']
        store
          .dispatch('system/TenantGetListByOwner', {
            ownerId: userInfo.UserId,
          })
          .then((data) => {
            this.list = data.Data
          })
          .catch((e) => {
            console.log(e + 'TenantGetListByOwner')
          })
      },
      copy(url) {
        this.$copyText(url).then(
          function (e) {
            Toast.success('链接已复制到粘贴板')
          },
          function (e) {
            Toast.fail('复制失败，请手动复制')
          }
        )
      },
      open(url) {
        window.location.href = url
      },
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: #b57e48;
  }
</style>
